import { Code, Divider } from '@vk-cloud-solutions/marketing-ui';
import { createElement, ReactNode } from 'react';
import { Components, Options } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { figcaption } from '~components/Markdown/components/figcaption';
import { image } from '~components/Markdown/components/image';
import { table } from '~components/Markdown/components/table';

export const MARKDOWN_REMARK_PLUGINS: Options['remarkPlugins'] = [
  [remarkGfm, { singleTilde: false }],
];

export const MARKDOWN_REHYPE_PLUGINS: Options['rehypePlugins'] = [
  [rehypeRaw, { allowDangerousHtml: false }],
];

const BLOCK_TAGS = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'blockquote',
  'pre',
];

type BlockProps = Record<string, unknown> & { node?: unknown };

const withoutNode = (props: BlockProps) => {
  const rest: Record<string, unknown> = { ...props };
  delete rest.node;
  return rest;
};

const strapiBlockComponents = (source?: string): Components =>
  Object.fromEntries(
    BLOCK_TAGS.map((tag) => [
      tag,
      (props: BlockProps) =>
        createElement(tag, {
          ...withoutNode(props),
          ...(source
            ? {
                'data-strapi-source': source,
                'data-strapi-markdown': '',
              }
            : {}),
        }),
    ]),
  ) as Components;

const strapiTable =
  (source?: string): Components['table'] =>
  ({ children }: { children?: ReactNode }) =>
    table({ children, source });

export const createMarkdownComponents = (
  source?: string,
  overrides?: Components,
): Components => ({
  table: strapiTable(source),
  code: Code,
  img: image,
  figcaption: figcaption,
  hr: Divider,
  ...strapiBlockComponents(source),
  ...overrides,
});
